import { render, staticRenderFns } from "./SendCouponCard.vue?vue&type=template&id=0df30218"
import script from "./SendCouponCard.vue?vue&type=script&lang=js"
export * from "./SendCouponCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports